// Text > Text
import React from 'react'
import { TextProps } from './IText'

const Text: React.FC<TextProps> = ({ children, ...rest }) => {
	return <p {...rest}>{children}</p>
}

export default Text
